import type { Locale } from "@commerce-frontend/i18n/types";
import { type CountrySpecificContainerFragmentFragment, graphql } from "@commerce-frontend/types";
import type React from "react";
import { RenderBlock } from "../RenderBlock/RenderBlock";

graphql(/* GraphQL */ `
	fragment CountrySpecificContainerFragment on CountrySpecificContainer {
		__typename
		id
		countries
		countrySpecificContainerBody: body {
			...BaseBlocksFragment
		}
	}
`);

type Props = {
	data: CountrySpecificContainerFragmentFragment;
	locale: Locale;
} & React.HTMLAttributes<HTMLDivElement>;

export const CountrySpecificContainer = ({ data, locale }: Props) => {
	return (
		<>
			{data.countrySpecificContainerBody?.map((block) => {
				if (!block || !("__typename" in block)) {
					return null;
				}

				return <RenderBlock key={block.id} block={block} locale={locale} />;
			})}
		</>
	);
};
